import CloseIcon from '@assets/images/icons/modal/close.svg?react'
import StopIcon from '@assets/images/icons/stop.svg?react'
import {
  setActiveCrawlerJob,
  setFinishedCrawlerJob,
} from '@storeOld/reducers/crawler'
import type React from 'react'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useUnmount } from 'react-use'

import { useAuth, useCrawler } from '@/hooks'
import { EMOJI_LIST } from '../../Modal/Import/constants'
import { useAnimation } from '../../Modal/Import/hooks'
import { useCrawlerStopJob } from '../hooks/useCrawlerStopJob'
import css from './CrawlerActive.module.scss'

type CrawlerActiveProps = {
  jobId: string
}

export const CrawlerActive: React.FC<CrawlerActiveProps> = ({ jobId }) => {
  const dispatch = useDispatch()
  const { id: userId } = useAuth()
  const { stopBackgroundJob, cancelBackgroundJob } = useCrawlerStopJob()
  const { emoji } = useAnimation(EMOJI_LIST)
  const [url, setUrl] = useState<string | null>(null)

  const { progress, close: closeSse } = useCrawler({
    url,
    onStopped: () => {
      // @todo implement action
      // @ts-expect-error
      dispatch(setActiveCrawlerJob(null))
    },
    onFinished: () => {
      // @todo implement action
      // @ts-expect-error
      dispatch(setActiveCrawlerJob(null))
      // @todo implement action
      // @ts-expect-error
      dispatch(setFinishedCrawlerJob(jobId))
    },
  })

  useEffect(() => {
    const url = new URL(`${import.meta.env.VITE_GENERATOR_URL!}/jobs/active`)
    url.searchParams.append('userId', userId)
    url.searchParams.append('jobId', jobId)
    setUrl(url.toString())
  }, [jobId])

  useUnmount(() => {
    closeSse?.()
  })

  return (
    <div className={css.status}>
      <div className={css.statusEmoji}>{emoji}</div>
      <div className={css.statusBody}>
        <div className={css.statusHeader}>
          <div className={css.statusTitle}>
            <span>Crawling</span>
            <span className={css.statusLink}>{progress.url}</span>
          </div>
          <div className={css.statusAside}>
            <span>
              {progress.scanned} of {progress.totalCount}
            </span>
            <div className={css.headerSplitter} />
            <div
              onClick={() => stopBackgroundJob(jobId)}
              className={css.headerButton}
            >
              <StopIcon />
              <span>Stop</span>
            </div>
            <div className={css.headerSplitter} />
            <div
              onClick={() => cancelBackgroundJob(jobId)}
              className={css.headerButton}
            >
              <CloseIcon />
            </div>
          </div>
        </div>
        <div className={css.statusProgressBar}>
          <div
            className={css.statusProgressBarInner}
            style={{
              width: `${progress.progressPercentage}%`,
            }}
          />
        </div>
      </div>
    </div>
  )
}
